const OVERLAY_EXCLUDED_URLS = ['/journeyActionLog'];

export default OVERLAY_EXCLUDED_URLS;
